import { useQuery, UseQueryOptions } from '@lumapps/base-api/react-query';

import { getCategories, learningCatalogQueryKeys } from '../api';

export const useCatalogCategories = (locale: string, options?: UseQueryOptions) => {
    /**
     * Fetch the learning available catalogs
     * based on the user current language
     * */
    const queryResult = useQuery({
        queryKey: learningCatalogQueryKeys(locale),
        queryFn: () => getCategories(locale),
        cacheTime: Infinity,
        staleTime: Infinity,
        ...options,
    });

    return queryResult;
};
